import { BasicProperties } from "../BasicProperties";

export class BasicDialogProperties extends BasicProperties {
    constructor() {
        super();
    }
}
